import {
	Alert,
	Autocomplete,
	Box,
	Button,
	Chip,
	FormControl,
	IconButton,
	InputAdornment,
	Snackbar,
	Tab,
	Tabs,
	TextField,
	useTheme,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import {
	Outlet,
	useNavigate,
	useOutletContext,
	useParams,
} from "react-router-dom";
import { Add, Clear, Search, Groups } from "@mui/icons-material";
import useStyles from "./styles";
import api from "../../services/api";
import Home from "../home";
import CadastroCliente from "../forms/cadastro";
import ModalCriarGrupo from "../forms/grupoEconomico";
import { getClienteOptionLabel } from "../../components/grupoEconomico/helpers";
import TagCliente from "../../components/tagCliente";
import TopBarFilter from "../../components/topBarFilter";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import VirtualizedAutocomplete from "../../components/virtualization/virtualizedAutocomplete";
import scrollClicker from "../../utils/scrollClicker";
import { set } from "zod";
import { alpha, style } from "@mui/system";

export default function Perfil() {
	const theme = useTheme();
	const styles = useStyles(theme);
	const [snackbar, setSnackbar] = useState(null);
	const id = useParams();
	const [value, setValue] = useState(0);
	const [clientes, setClientes] = useState([]);
	const [buscarUsuario, setBuscarUsuario] = useState("");
	const [selectedCliente, setSelectedCliente] = useState(null);

	const [openModalCreate, setOpenModalCreate] = useState(false);
	const [openModalCriarGrupo, setOpenModalCriarGrupo] = useState(false);
	const [windowWith, setWindowWith] = useState(window.innerWidth);
	const [openFilter, setOpenFilter] = useState(false);
	const [loading, setLoading] = useState(false);
	const [changed, setChanged] = useState(false);

	const [searchTerm, setSearchTerm] = useState("");
	const [serviceFilter, setServiceFilter] = useState("");
	const [services, setServices] = useState([]);

	// Filtros da aba Acessos (opções de tags vêm da própria aba)
	const [tagFilter, setTagFilter] = useState([]);
	const [tipoFilter, setTipoFilter] = useState([]);
	const [tagOptions, setTagOptions] = useState([]);
	const tiposAcesso = [
		{ label: "VM/Servidor", value: 0 },
		{ label: "Banco de Dados", value: 1 },
		{ label: "Acesso Web", value: 2 },
		{ label: "VPN", value: 3 },
	];

	/*   const [labelErp, setLabelErp] = useState(""); */
	const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
	const labelErp =
		erp === "HUBSOFT"
			? "Serviços"
			: erp === "VOALLE"
				? "Contratos"
				: erp === "IXC"
					? "Contratos"
					: "Serviços";

	const navigate = useNavigate();
	const { controllerDashboard, setControllerDashboard } = useOutletContext();

	// Estados para controle do modal de saída e aba pendente
	const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
	const [pendingTab, setPendingTab] = useState(null);

	useEffect(() => {
		//Funções a serem executadas ao carregar a página
		apiGetClientes();

		const handleResize = () => {
			setWindowWith(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);
	}, []);
	const navPages = [
		`/home/perfil/servicos/${selectedCliente?.id}`,
		`/home/perfil/config/${selectedCliente?.id}`,
		selectedCliente?.isGrupoEconomico
			? `/home/perfil/grupoEconomico/${selectedCliente?.id}`
			: `/home/perfil/${selectedCliente?.id}`,
	];

	// Seleciona a tab de acordo com a página atual
	useEffect(() => {
		const pageName = window.location.pathname;

		let selectedIndex = 2; // Default to Perfil (index 2)
		if (pageName.includes("/home/perfil/servicos")) {
			selectedIndex = 0;
		} else if (pageName.includes("/home/perfil/config")) {
			selectedIndex = 1;
		}

		setValue(selectedIndex);

		if (!!clientes) {
			const clienteEncontrado = clientes?.find(
				(cliente) => cliente?.id === id?.id,
			);
			setSelectedCliente(clienteEncontrado || null);
		}
	}, [window.location.pathname]);

	// Mudança do perfil exibido
	useEffect(() => {
		if (selectedCliente) {
			let path = window.location.pathname;

			if (path.endsWith("perfil") || path.endsWith("perfil/")) {
				// Clicou num cliente vindo da lista principal ou trocou de cliente
				navigate(`/home/perfil/servicos/${selectedCliente?.id}`);
			} else {
				// Já está dentro de uma aba (Acessos, Equipamentos, Perfil), apenas troca o ID
				path = path.split("/").slice(0, -1).join("/");
				if (
					path.endsWith("grupoEconomico") &&
					!selectedCliente.isGrupoEconomico
				) {
					path = "/home/perfil";
				} else if (
					path.endsWith("perfil") &&
					selectedCliente.isGrupoEconomico
				) {
					path = "/home/perfil/grupoEconomico";
				}
				navigate(`${path}/${selectedCliente?.id}`);
			}

			// Aplica quaisquer mudanças ao array de clientes
			setClientes((prev) =>
				prev.map((cliente) =>
					cliente?.id === selectedCliente?.id ? selectedCliente : cliente,
				),
			);
		}
	}, [selectedCliente]);

	// Uso de api para receber a lista de clientes
	async function apiGetClientes() {
		setLoading(true);
		if (controllerDashboard) {
			controllerDashboard.abort();
		}
		const newController = new AbortController();
		const signal = newController.signal;
		setControllerDashboard(newController);
		try {
			const response = await api.get("/getClients", { signal });

			setClientes(response.data);

			const clienteEncontrado = response?.data?.find(
				(cliente) => cliente?.id === id?.id,
			);

			if (clienteEncontrado) {
				setSelectedCliente(clienteEncontrado || null);

				const clientStorage = {
					interfaceId: "",
					clienteId: clienteEncontrado?.id,
					hostId: "",
					selectTime: 5,
					initialDate: "",
					finalDate: "",
				};

				localStorage.setItem("filterData", JSON.stringify(clientStorage));
				return;
			}

			const selectedClientStorage = JSON.parse(
				localStorage.getItem("filterData"),
			);
			if (selectedClientStorage && !clienteEncontrado) {
				const selectClient = response?.data?.find(
					(cliente) => cliente?.id === selectedClientStorage?.clienteId,
				);

				/*   navigate(`/home/perfil/${selectClient?.id}`); */
				setSelectedCliente(selectClient);
				return;
			}

			if (!clienteEncontrado && window.location.pathname.includes("perfil")) {
				navigate(`/home/perfil`);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}

	function handleNewClient(newClient) {
		let newArray = [...clientes];
		newArray.push(newClient);
		setClientes(newArray);
	}

	//Change tabs handler
	const handleChange = (event, newValue) => {
		// Navega normalmente se não há alterações pendentes
		navigate(navPages[newValue]);
		setValue(newValue);
		// }
	};

	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}
	const uniqueServiceNames = useMemo(() => {
		return [
			...new Set(
				services?.map(
					(service) => `${service?.id_cliente_servico} - ${service?.nome}`,
				),
			),
		]?.sort();
	}, [services]);

	const actions = [
		{
			icon: <FilterAltOutlinedIcon />,
			name: "Filtro",
			onClick: () => setOpenFilter(true),
		},
		{
			icon: <PersonAddAlt1OutlinedIcon />,
			name: "Novo Cliente",
			onClick: () => navigate("/administracao/integracaoErp"),
		},
	];

	const selectorComponentLeft = (
		<Box sx={styles.boxFilters}>
			<VirtualizedAutocomplete
				sx={{ width: 400, "@media (max-width:1349px)": { width: "100%" } }}
				value={selectedCliente}
				onChange={(_, newValue) => {
					setSelectedCliente(newValue);
					const clientStorage = {
						interfaceId: "",
						clienteId: newValue?.id,
						hostId: "",
						selectTime: 5,
						initialDate: "",
						finalDate: "",
					};

					localStorage.setItem("filterData", JSON.stringify(clientStorage));
				}}
				clearIcon={
					<Clear
						onClick={() => {
							localStorage.removeItem("filterData");
							setSelectedCliente(null);
							navigate("/home/perfil/");
						}}
					/>
				}
				size="small"
				options={clientes}
				getOptionLabel={(option) => getClienteOptionLabel(option)}
				// Opcao com o produto do cliente como chip, igual a tabela de clientes
				renderOption={(props, option) => (
					<li {...props}>
						<Box sx={styles.opcaoCliente}>
							{getClienteOptionLabel(option)}
							{option?.tagsCliente?.map((tag) => (
								<TagCliente key={tag?.id} tag={tag} compacto />
							))}
						</Box>
					</li>
				)}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Cliente"
						size="small"
						sx={styles.filterAutocomplete}
						// Chip do produto do cliente selecionado dentro do input, antes dos icones
						InputProps={{
							...params?.InputProps,
							endAdornment: (
								<>
									{selectedCliente?.tagsCliente?.map((tag) => (
										<TagCliente key={tag?.id} tag={tag} compacto />
									))}
									{params?.InputProps?.endAdornment}
								</>
							),
						}}
					/>
				)}
			/>
			{value === 0 && selectedCliente && (
				<Box sx={styles.boxFilters}>
					<Autocomplete
						multiple
						size="small"
						options={tiposAcesso}
						value={tipoFilter}
						getOptionLabel={(option) => option?.label || ""}
						isOptionEqualToValue={(option, val) => option?.value === val?.value}
						onChange={(_, newValue) => setTipoFilter(newValue)}
						sx={styles.searchField}
						renderInput={(params) => (
							<TextField {...params} label="Filtrar por tipo" />
						)}
					/>
					<Autocomplete
						multiple
						size="small"
						options={tagOptions}
						value={tagFilter}
						getOptionLabel={(tag) => tag?.name || ""}
						isOptionEqualToValue={(option, val) => option?.id === val?.id}
						onChange={(_, newValue) => setTagFilter(newValue)}
						noOptionsText="Nenhuma tag encontrada"
						sx={styles.searchField}
						renderTags={(tags, getTagProps) =>
							tags.map((tag, index) => (
								<Chip
									{...getTagProps({ index })}
									key={tag?.id}
									label={tag?.name}
									size="small"
									sx={{
										bgcolor: alpha(tag?.color || "#888", 0.2),
										color: tag?.color,
									}}
								/>
							))
						}
						renderInput={(params) => (
							<TextField {...params} label="Filtrar por tags" />
						)}
					/>
				</Box>
			)}
			{value === 3 && (
				<Box sx={styles.boxFilters}>
					<FormControl fullWidth variant="outlined" size="small">
						<Autocomplete
							id="free-solo-demo"
							value={serviceFilter}
							size="small"
							options={uniqueServiceNames || []}
							getOptionLabel={(option) => option || ""}
							sx={styles.searchField}
							onChange={(event, newValue) => {
								setServiceFilter(newValue);
							}}
							renderInput={(params) => (
								<TextField {...params} label={`Filtrar por ${labelErp}`} />
							)}
						/>
					</FormControl>
					<Box sx={{ width: "100%" }}>
						<TextField
							size="small"
							fullWidth
							variant="outlined"
							placeholder="Endereço, status, etc..."
							label="Buscar Serviço"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							sx={styles.searchField}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Search />
									</InputAdornment>
								),
								endAdornment: searchTerm ? (
									<InputAdornment position="end">
										<IconButton onClick={() => setSearchTerm("")} edge="end">
											<Clear size={"small"} />
										</IconButton>
									</InputAdornment>
								) : null,
							}}
						/>
					</Box>
				</Box>
			)}

			{!selectedCliente && (
				<TextField
					label="Buscar cliente"
					variant="outlined"
					autoComplete="off"
					placeholder="Nome, Email, Asn, etc..."
					value={buscarUsuario}
					size="small"
					onChange={(event) => {
						setBuscarUsuario(event?.target?.value?.trimStart());
					}}
					sx={styles.searchField}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<Search />
							</InputAdornment>
						),
						endAdornment: buscarUsuario ? (
							<InputAdornment position="end">
								<IconButton onClick={() => setBuscarUsuario("")} edge="end">
									<Clear size={"small"} />
								</IconButton>
							</InputAdornment>
						) : null,
					}}
				/>
			)}
		</Box>
	);
	const handleUsuarioId = () => {
		let result = JSON.parse(localStorage.getItem("user"));
		// Verifica se a propriedade rlPermissoesUsuario existe e é um array
		if (Array.isArray(result?.usuario?.rlPermissoesUsuario)) {
			// Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
			for (let permissao of result?.usuario?.rlPermissoesUsuario) {
				if (permissao?.permissao?.codigoPermissao.toUpperCase() === "ADM") {
					return true;
				}
			}
			return false;
		}
	};

	// Produto do cliente selecionado (pra todos) e os botoes de criar (so ADM)
	const selectorComponentRight = (
		<Box sx={styles.barraSeletorDireita}>
			{selectedCliente?.tagsCliente?.map((tag) => (
				<TagCliente key={tag?.id} tag={tag} />
			))}
			{handleUsuarioId() && (
				<>
					<Button
						variant="outlined"
						startIcon={<Groups />}
						onClick={() => setOpenModalCriarGrupo(true)}
						sx={{
							color: theme.palette.text.main,
							borderColor: theme.palette.text.main,
						}}
					>
						Criar Grupo
					</Button>
					<Button
						variant="outlined"
						startIcon={<Add />}
						onClick={() => setOpenModalCreate(true)}
						sx={{
							color: theme.palette.text.main,
							borderColor: theme.palette.text.main,
						}}
					>
						Novo Cliente
					</Button>
				</>
			)}
		</Box>
	);

	return (
		<>
			<Box sx={styles.pageBox}>
				<TopBarFilter
					actions={actions}
					selectorComponentRight={selectorComponentRight}
					selectorComponentLeft={selectorComponentLeft}
					windowWidth={windowWith}
					openFilter={openFilter}
					setOpenFilter={setOpenFilter}
				/>
				{selectedCliente && window?.location?.pathname?.includes("perfil/") ? (
					<Box sx={styles.container}>
						<Box sx={styles.perfilTabs}>
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="basics tabs config"
								variant="scrollable"
								scrollButtons="auto"
								allowScrollButtonsMobile
							>
								<Tab
									label={"Acessos"}
									{...a11yProps(0)}
									onMouseDown={(e) => scrollClicker(e, false, navPages[0])}
								/>
								<Tab
									label="Equipamentos"
									{...a11yProps(1)}
									onMouseDown={(e) => scrollClicker(e, false, navPages[1])}
								/>
								<Tab
									label="Perfil"
									{...a11yProps(2)}
									onMouseDown={(e) => scrollClicker(e, false, navPages[2])}
								/>
							</Tabs>
						</Box>

						<Outlet
							context={[
								setSnackbar,
								selectedCliente,
								setSelectedCliente,
								changed,
								searchTerm,
								setSearchTerm,
								setChanged,
								serviceFilter,
								setServiceFilter,
								services,
								setServices,
								setValue,
								{
									tagFilter,
									setTagFilter,
									tipoFilter,
									setTipoFilter,
									setTagOptions,
								},
							]}
						/>
					</Box>
				) : (
					<Home
						rows={clientes}
						setRows={setClientes}
						setSelectedCliente={setSelectedCliente}
						loading={loading}
						buscarUsuario={buscarUsuario}
						setBuscarUsuario={setBuscarUsuario}
					/>
				)}
			</Box>

			<CadastroCliente
				openModal={openModalCreate}
				setOpenModal={setOpenModalCreate}
				handleNewClient={handleNewClient}
				setSnackbar={setSnackbar}
			/>

			<ModalCriarGrupo
				openModal={openModalCriarGrupo}
				setOpenModal={setOpenModalCriarGrupo}
				clientes={clientes}
				onCreated={() => {
					apiGetClientes();
				}}
				setSnackbar={setSnackbar}
			/>
			<Snackbar
				open={!!snackbar}
				onClose={() => setSnackbar(null)}
				autoHideDuration={2500}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert {...snackbar} onClose={() => setSnackbar(null)} />
			</Snackbar>
		</>
	);
}
